// src/Pages/Landing/DjVarsinaisSuomiLanding.jsx
import React, { useMemo } from "react";
import NeonButton from "../../components/ResponsiveButton/NeonButton.jsx";
import { trackLandingCta } from "../../utils/analytics";

/**
 * DJ Varsinais-Suomi -landing React Shelliin.
 * Metat/JSON-LD tulevat WordPressistä.
 * Ei vielä dynaamista hinnastoa (vain 1 DJ Buukkerissa).
 */

export default function DjVarsinaisSuomiLanding() {
  // Paikallisen päivän ISO (YYYY-MM-DD)
  const today = useMemo(() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }, []);

  return (
    <section className="relative max-w-6xl mx-auto px-4 pt-24 pb-24">
      {/* Hero / ingressi */}
      <header className="rounded-2xl overflow-hidden ring-1 ring-black/10 dark:ring-white/10 bg-white/70 dark:bg-black/50 backdrop-blur-md p-8 md:p-12 shadow-lg">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight text-black dark:text-white">
          DJ Varsinais-Suomessa – vapaat DJ:t
        </h1>

        <p className="mt-4 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
          Buukkerista löydät Varsinais-Suomen vapaat DJ:t reaaliaikaisesti.{" "}
          <strong>
            Valitse päivämäärä, katso vapaat DJ:t ja pyydä tarjous parilla
            klikkauksella.
          </strong>
        </p>

        <p className="mt-3 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
          Tarjottu hinta on <strong>kokonaishinta (sis. matkakulut)</strong>.
          Lisäksi DJ:ltä voi tilata lisäpalveluja tarpeen ja mahdollisuuksien
          mukaan – esimerkiksi lisävaloja, äänentoiston tai tapahtuman
          taustamusiikkia. Katso DJ:n profiilista tarkemmin, mitä kaikkea on
          tarjolla.
        </p>

        {/* CTA-napit */}
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <a
            href={`/?type=dj&maakunta=varsinais-suomi&date=${today}&clear=1#tulokset`}
            aria-label="Näytä tämän päivän vapaat DJ:t (Varsinais-Suomi)"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "varsinais-suomi",
                placement: "hero_primary_today",
              })
            }
          >
            <NeonButton variant="primary" size="md" className="font-semibold">
              Näytä tämän päivän vapaat (Varsinais-Suomi)
            </NeonButton>
          </a>

          <a
            href="/?type=dj&book=1&maakunta=varsinais-suomi&clear=1#tulokset"
            aria-label="Avaa DJ-pikahaku (Varsinais-Suomi)"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "varsinais-suomi",
                placement: "hero_quick_search",
              })
            }
          >
            <NeonButton variant="secondary" size="md" className="font-semibold">
              Avaa pikahaku
            </NeonButton>
          </a>
        </div>
      </header>

      {/* Hintateksti ilman dynaamista boxia */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <p className="text-black/80 dark:text-white/80 text-base md:text-lg">
          DJ:n hinta määräytyy{" "}
          <strong>keikan keston ja matkakulujen</strong> mukaan.
          Buukkerissa näet kokonaishinnan jo tarjouspyyntövaiheessa – ilman
          piilokuluja. Lopullinen hinta täsmentyy aina{" "}
          <strong>tarjouksessa</strong>.
        </p>
      </div>

      {/* Ristiinlinkitys */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <p className="text-black/80 dark:text-white/80 text-base md:text-lg">
          Tarvitsetko bilebändiä tai trubaduuria Varsinais-Suomessa? Siirry{" "}
          <a className="underline" href="/bilebandi-varsinais-suomi/">
            Bilebändi Varsinais-Suomi
          </a>{" "}
          tai{" "}
          <a className="underline" href="/trubaduuri-varsinais-suomi/">
            Trubaduuri Varsinais-Suomi
          </a>
          {" "}
          -sivulle. Lue myös:{" "}
          <a
            className="underline"
            href="https://buukkeri.fi/blogi/nain-loydat-taydellisen-esiintyjan-juhliisi"
          >
            Näin löydät täydellisen esiintyjän juhliisi
          </a>
          .
        </p>
      </div>
    </section>
  );
}
